<template>
  <a-card>
    <div class="card-content">
      <!-- <div class="page-title">{{ $route.query.id ? '编辑资源包' : '新增资源包' }}</div> -->
      <div style="margin: auto" :style="{ width: currentStep === 0 ? '700px' : '70%' }">
        <a-steps :current="currentStep" labelPlacement="vertical">
          <a-step title="基础信息"> </a-step>
          <a-step title="配置教学资源" />
        </a-steps>
      </div>
      <div v-show="currentStep === 0" class="currentStep1">
        <div class="title">基本信息</div>
        <a-form :form="basiceForm" :labelCol="{ span: 4 }" :wrapperCol="{ span: 16 }" :rules="rules">
          <a-form-item label="资源包名称">
            <a-input @change="e => e.target.value = e.target.value.trim()" placeholder="请输入资源包" v-decorator="['name', { rules: rules.name }]" :maxLength="20" />
          </a-form-item>
          <a-form-item label="资源包简介">
            <a-textarea :rows="4" :maxLength="150" placeholder="请输入简介，字数限制200字" v-decorator="['description', {}]" />
          </a-form-item>
          <a-form-item label="资源包备注">
            <a-textarea :rows="4" :maxLength="150" placeholder="请输入备注，字数限制200字" v-decorator="['remark', {}]" />
          </a-form-item>
          <a-form-item label="资源包状态" required>
            <a-switch class="open-serve" checked-children="启用" un-checked-children="禁用" v-decorator="['enabled', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-form-item label="资源包封面" style="display: none">
            <a-input class="open-serve" checked-children="启用" un-checked-children="禁用" v-decorator="['fileList']" />
          </a-form-item>
          <a-form-item label="资源包封面" :wrapperCol="{ span: 16 }">
            <!-- t_rource_bg -->
            <a-tooltip ref="tooltip" placement="left">
              <template slot="title"> 请上传资源包封面 </template>
              <div class="upload-box">
                <div style="width: 260px">
                  <a-upload name="avatar" accept=".png,.jpg,.jpeg" list-type="picture-card" :show-upload-list="false" :beforeUpload="beforeUpload" :customRequest="customRequest">
                    <img
                      style="width: 200px; height: 200px"
                      v-if="basiceForm.getFieldsValue().fileList && basiceForm.getFieldsValue().fileList.dataUrl"
                      :src="basiceForm.getFieldsValue().fileList.dataUrl"
                      @click="$refs['tooltip'].sVisible = false"
                      alt="avatar"
                    />
                    <div v-else @click="$refs['tooltip'].sVisible = false">
                      <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
                      <div class="ant-upload-text">上传封面</div>
                    </div>
                  </a-upload>
                </div>
                <div style="flex: 1; color: #999494">
                  <p>文件大小：不超过5M</p>
                  <p>建议尺寸： 1:1</p>
                </div>
              </div>
            </a-tooltip>
          </a-form-item>
          <a-form-item :wrapperCol="{ offset: 4 }">
            <a-button @click="$router.back()" :disabled="submitLoading">取消</a-button>
            <a-button type="primary" @click="saveBaiceForm" :loading="submitLoading" style="margin-left: 16px">下一步</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-show="currentStep === 1" class="currentStep2">
        <step2 :pId="pId" />
        <a-row type="flex" :justify="currentStep === 1 ? 'end' : 'center'" style="margin-top: 20px; padding: 0 24px;">
          <a-button @click="currentStep = 0">上一步</a-button>
          <a-button type="primary" @click="saveSubmit" :loading="submitLoading" style="margin-left: 16px">完成</a-button>
        </a-row>
      </div>
    </div>
  </a-card>
</template>
<script>
import step2 from './components/step2.vue'
import $Bus from '@/pages/projectImpl/js/eventBus'
import api from '@/requests/apis'

const routes = [
  '首页',
  '内容中心',
  {
    path: '/content/TResources',
    breadcrumbName: '教学资源',
    meta: {
      title: '教学资源',
      getTitle: true,
    },
  },
  {
    path: '/content/addTResources',
    breadcrumbName: '添加',
    meta: {
      title: '添加',
      getTitle: true,
    },
  },
]
export default {
  components: {
    step2,
  },
  data() {
    return {
      submitLoading: false,
      uploadLoading: false,
      currentStep: 0,
      basiceForm: this.$form.createForm(this, { name: 'coordinated' }),
      rules: {
        name: [{ required: true, message: '请输入资源包名称', trigger: 'blur' }],
        remark: [{ required: false, message: '请输入备注', trigger: 'blur' }],
        description: [{ required: false, message: '请输入简介', trigger: 'blur' }],
      },
      pId: undefined,
    }
  },
  created() {
    if (this.$route.query.id) {
      // this.getDetail(this.$route.query.id)
      const params = JSON.parse(this.$route.query.params)
      this.pId = params.id
      this.$nextTick(() => {
        this.basiceForm.setFieldsValue({
          ...params,
          fileList: {
            path: params.icon,
            dataUrl: this.$filterUrl(params.icon),
          },
        })
      })
      routes[3].breadcrumbName = '编辑教学资源包'
      routes[3].meta.title = '编辑教学资源包'
      $Bus.$emit('pageHeaderTitle', '编辑教学资源包')
    } else {
      this.$nextTick(() => {
        this.basiceForm.setFieldsValue({
          fileList: {
            path: 'https://cdn.iquizoo.com/static/img/common/t_rource_bg.png',
            dataUrl: this.$filterUrl('https://cdn.iquizoo.com/static/img/common/t_rource_bg.png'),
          },
        })
      })
      routes[3].breadcrumbName = '添加'
      routes[3].meta.title = '添加'
      $Bus.$emit('pageHeaderTitle', '添加教学资源包')
    }

    $Bus.$emit('pageHeaderBreadcrumb', routes)
  },
  methods: {
    getDetail(id) {
      this.$http.TResource.getDetail({ id }).then((res) => {
          this.basiceForm.setFieldsValue({
            ...res.data,
            fileList: {
              path: res.data.icon,
              dataUrl: this.$filterUrl(res.data.icon),
            },
          })
      })
    },
    beforeUpload(file) {
      const prfix = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp']
      return new Promise((resolve, reject) => {
        const fix = file.name.split('.').slice(-1)[0]
        if (!prfix.includes(fix)) {
          this.$message.error('图片必须是png，jpe，jpeg，gif，bmp，webp 格式')
          return reject()
        }
        if (file.size > 1024 * 1024 * 5) {
          this.$message.error('图片大小不能超过5M')
          return reject()
        }
        const blob = file.slice(0, file.size, file.type)
        const image = new Image()
        image.src = window.URL.createObjectURL(blob)
        image.onload = () => {
          if (image.width / image.height != 1) {
            this.$message.error('图片比例必须为 1:1')
            reject()
          }
          resolve()
        }
      })
    },
    customRequest(file) {
      const formData = new FormData()
      formData.append('imgFile', file.file || new File([file.blob], file.fileName))
      this.uploadLoading = true
      this.$http.File.upload(api.File.upload + '?filePath=content/resource', formData).then((res) => {
        this.uploadLoading = false
        this.basiceForm.setFieldsValue({
          fileList: {
            path: res.data,
            dataUrl: this.$filterUrl(res.data),
          },
        })
      })
    },
    saveBaiceForm() {
      this.basiceForm.validateFields((err, values) => {
        if (!err) {
          const params = {
            ...values,
            icon: values.fileList.path,
            description: values.description ? values.description : '',
            remark: values.remark ? values.remark : '',
            seriesId: this.$store.getters["course/getSeriesInfo"]().id
          }
          let http = this.$http.CourseResource.AddResourcePackage
          if (this.pId) {
            params.id = this.pId
            http = this.$http.CourseResource.EditResourcePackage
          }
          delete params.fileList
          this.submitLoading = true
          http(params).then(res => {
            this.pId = res.data
            this.currentStep = 1
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    saveSubmit() {
      this.$router.back()
    },
  },
}
</script>
<style lang="less" scoped>
.upload-box {
  display: flex;
}
.card-content {
  > .page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
  .currentStep1 {
    width: 600px;
    margin: 12px auto;
    ::v-deep .ant-upload.ant-upload-disabled {
      cursor: pointer;
    }
  }
  .currentStep2 {
    margin: 12px auto;
    margin-top: 20px;
  }
  .title {
    font-weight: 700;
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .title::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 16px;
    background: #999;
    transform: translateY(2px);
    margin-right: 4px;
  }
}
</style>
